/*
    Create by Pierre Marsot on 05/12/2017
*/
import {
    LOAD_USER_ERROR,
    LOAD_USER_SUCCESS,
    LOAD_BALISES_USER_ERROR,
    LOAD_BALISES_USER_SUCCESS,
    LOAD_INCIDENTS_USER_ERROR,
    LOAD_INCIDENTS_USER_SUCCESS,
} from '../actions/user';

let initialState = {
    user: null,
    balises: [],
    incidents: [],
};

export default function user(state = initialState, action = {}){
    switch(action.type){
        case LOAD_USER_ERROR:
            return {
                ...state,
                user: null,
            };

        case LOAD_USER_SUCCESS:
            if (!action || !action.user) {
                return {
                    ...state,
                    user: null,
                };
            }

            return {
                ...state,
                user: action.user,
            };

        case LOAD_BALISES_USER_ERROR:
            return {
                ...state,
                balises: [],
            };

        case LOAD_BALISES_USER_SUCCESS:
            if (!action || !action.balises) {
                return {
                    ...state,
                    balises: [],
                };
            }

            return {
                ...state,
                balises: action.balises,
            };

        case LOAD_INCIDENTS_USER_ERROR:
            return {
                ...state,
                incidents: [],
            };

        case LOAD_INCIDENTS_USER_SUCCESS:
            if (!action || !action.incidents) {
                return {
                    ...state,
                    incidents: [],
                };
            }

            return {
                ...state,
                incidents: action.incidents,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js